import { styled } from '@mui/material/styles'
import React from 'react'
import PropTypes from 'prop-types'

const CardContainer = styled('div')(() => ({
  background: 'white',
  border: '1px solid lightgray',
  borderRadius: '10px',
  boxShadow: '0px 0px 19px -11px rgba(0,0,0,0.75)',
  color: 'black',
  padding: '10px 30px',
  textAlign: 'center',
  maxWidth: '175px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}))

const CardTitle = styled('div')(() => ({
  fontSize: '12px',
  color: 'darkslategray',
  marginBottom: '8px'
}))

const CardScore = styled('div')(() => ({
  fontSize: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px',
  borderRadius: '50%',
  height: '60px',
  width: '60px',
  marginBottom: '8px'
}))

const ProgressBar = styled('div')(() => ({
  height: '6px',
  width: '100%',
  backgroundColor: 'lightgray',
  borderRadius: '10px',
  marginBottom: '8px',
  position: 'relative'
}))

const ProgressBarInner = styled('div')(() => ({
  backgroundColor: '#18AFFF',
  position: 'absolute',
  left: '0',
  height: '100%',
  borderRadius: '10px'
}))

const CardName = styled('div')(() => ({
  fontSize: '12px'
}))

const ScoreCard = ({ name, score }) => {
  const hydrationScore = score < 0 ? -1 : Math.round(score * 100)

  let scoreColor = '#27F176'
  if (hydrationScore < 0) {
    scoreColor = '#EFEFEF'
  } else if (hydrationScore >= 0 && hydrationScore < 26) {
    scoreColor = '#FF375F'
  } else if (hydrationScore >= 26 && hydrationScore < 51) {
    scoreColor = '#FF7900'
  } else if (hydrationScore >= 51 && hydrationScore < 76) {
    scoreColor = '#FFDD00'
  }

  return (
    <CardContainer>
      <CardTitle>Bed 1</CardTitle>
      <CardScore style={{ backgroundColor: scoreColor }}>{hydrationScore < 0 ? 'NA' : hydrationScore}</CardScore>
      <ProgressBar>
        <ProgressBarInner style={{ width: hydrationScore < 0 ? '0%' : `${hydrationScore}%` }} />
      </ProgressBar>
      <CardName>{name}</CardName>
    </CardContainer>
  )
}

ScoreCard.propTypes = {
  name: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired
}

export default ScoreCard
